import mitt from 'mitt';

var ps = /*#__PURE__*/Object.getOwnPropertyDescriptor(History.prototype, 'pushState');
var rs = /*#__PURE__*/Object.getOwnPropertyDescriptor(History.prototype, 'replaceState');
var oldPushState = history.pushState;
var oldReplaceState = history.replaceState;
/**
 * 拦截 `history.pushState()`/`history.replaceState()` 补发自定义事件
 */

function interceptHistory(overwrite) {
  if (overwrite === void 0) {
    overwrite = false;
  }

  var eventTarget = new EventTarget();

  if (ps && ps.configurable && typeof ps.value === 'function') {
    oldPushState = history.pushState;
    var pushState = overwrite ? ps.value : oldPushState;
    Object.defineProperty(history, 'pushState', {
      configurable: true,
      enumerable: true,
      value: function value(data, title, url) {
        var oldURL = window.location.href;
        pushState.call(history, data, title, url);
        eventTarget.dispatchEvent(new CustomEvent('pushstate', {
          detail: {
            state: data,
            oldURL: oldURL,
            newURL: window.location.href
          }
        }));
      },
      writable: true
    });
  } else {
    console.error('[history-interceptor] 不支持拦截 `history.pushState()`');
  }

  if (rs && rs.configurable && typeof rs.value === 'function') {
    oldReplaceState = history.replaceState;
    var replaceState = overwrite ? rs.value : oldReplaceState;
    Object.defineProperty(history, 'replaceState', {
      configurable: true,
      enumerable: true,
      value: function value(data, title, url) {
        var oldURL = window.location.href;
        replaceState.call(history, data, title, url);
        eventTarget.dispatchEvent(new CustomEvent('replacestate', {
          detail: {
            state: data,
            oldURL: oldURL,
            newURL: window.location.href
          }
        }));
      },
      writable: true
    });
  } else {
    console.error('[history-interceptor] 不支持拦截 `history.replaceState()`');
  }

  return eventTarget;
}
/**
 * 恢复 `history.pushState()`/`history.replaceState()` 原始行为
 */

function undoInterceptHistory(overwrite) {
  if (overwrite === void 0) {
    overwrite = false;
  }

  if (ps && ps.configurable && typeof ps.value === 'function') {
    var pushState = overwrite ? ps.value : oldPushState;
    Object.defineProperty(history, 'pushState', {
      configurable: true,
      enumerable: true,
      value: pushState.bind(history),
      writable: true
    });
  } else {
    console.error('[history-interceptor] 不支持拦截 `history.pushState()`');
  }

  if (rs && rs.configurable && typeof rs.value === 'function') {
    var replaceState = overwrite ? rs.value : oldReplaceState;
    Object.defineProperty(history, 'replaceState', {
      configurable: true,
      enumerable: true,
      value: replaceState.bind(history),
      writable: true
    });
  } else {
    console.error('[history-interceptor] 不支持拦截 `history.replaceState()`');
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

var isHashEqual = function isHashEqual(url1, url2) {
  return new URL(url1).hash === new URL(url2).hash;
};
var log = function log(type, content) {
  console.log("[" + type + "]", content);
};

var HistoryObserver = /*#__PURE__*/function () {
  function HistoryObserver(options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    this.debug = false;
    this.emitter = mitt();
    this.eventTarget = interceptHistory();
    /**
     * 订阅事件
     */

    this.subscribe = function () {
      var et = _this.eventTarget;
      et.addEventListener('pushstate', _this.onPushStateInternal, false);
      et.addEventListener('replacestate', _this.onReplaceStateInternal, false);
      window.addEventListener('load', _this.onLoadInternal, false);
      window.addEventListener('popstate', _this.onPopStateInternal, false);
      window.addEventListener('hashchange', _this.onHashChangeInternal, false);
    };
    /**
     * 取消事件订阅
     */


    this.unsubscribe = function () {
      var et = _this.eventTarget;
      et.removeEventListener('pushstate', _this.onPushStateInternal, false);
      et.removeEventListener('replacestate', _this.onReplaceStateInternal, false);
      window.removeEventListener('load', _this.onLoadInternal, false);
      window.removeEventListener('popstate', _this.onPopStateInternal, false);
      window.removeEventListener('hashchange', _this.onHashChangeInternal, false);
    };
    /**
     * 发送消息
     */


    this.emit = function (type, payload) {
      _this.debug && log(type, payload);

      _this.emitter.emit(type, payload);
    };
    /**
     * 监听 `load` 事件
     */


    this.onLoadInternal = function () {
      var type = 'load';
      var payload = {
        url: window.location.href
      };

      _this.emit(type, payload);

      _this.onHistoryChangeInternal(_extends({
        type: type,
        state: null
      }, payload));
    };
    /**
     * 监听 `popstate` 事件
     * - `history.back()`
     * - `history.forward()`
     * - `history.go()`
     * - `location.hash = newHash`
     */


    this.onPopStateInternal = function (event) {
      var type = 'popstate';
      var payload = {
        url: window.location.href,
        state: event.state
      };

      _this.emit(type, payload);

      _this.onHistoryChangeInternal(_extends({
        type: type
      }, payload));
    };
    /**
     * 监听 `history.pushState()` 操作
     */


    this.onPushStateInternal = function (event) {
      var detail = event.detail;
      var oldURL = detail.oldURL,
          newURL = detail.newURL,
          state = detail.state;
      var type = 'pushstate';
      var payload = {
        url: window.location.href,
        state: state
      };

      _this.emit(type, payload);

      _this.onHistoryChangeInternal(_extends({
        type: type
      }, payload));

      if (!isHashEqual(oldURL, newURL)) {
        _this.onHistoryHashChangeInternal({
          type: type,
          oldURL: oldURL,
          newURL: newURL
        });
      }
    };
    /**
     * 监听 `history.replaceState()` 操作
     */


    this.onReplaceStateInternal = function (event) {
      var detail = event.detail;
      var oldURL = detail.oldURL,
          newURL = detail.newURL,
          state = detail.state;
      var type = 'replacestate';
      var payload = {
        url: window.location.href,
        state: state
      };

      _this.emit(type, payload);

      _this.onHistoryChangeInternal(_extends({
        type: type
      }, payload));

      if (!isHashEqual(oldURL, newURL)) {
        _this.onHistoryHashChangeInternal({
          type: type,
          oldURL: oldURL,
          newURL: newURL
        });
      }
    };
    /**
     * 监听合成的 `historychange` 事件
     */


    this.onHistoryChangeInternal = function (params) {
      var type = params.type,
          url = params.url,
          state = params.state;
      var syntheticType = 'historychange';
      var payload = {
        type: type,
        url: url,
        state: state
      };

      _this.emit(syntheticType, payload);
    };
    /**
     * 监听 `hashchange` 事件
     */


    this.onHashChangeInternal = function (event) {
      var oldURL = event.oldURL,
          newURL = event.newURL;
      var type = 'hashchange';
      var payload = {
        oldURL: oldURL,
        newURL: newURL
      };

      _this.emit(type, payload);

      _this.onHistoryHashChangeInternal(_extends({
        type: type
      }, payload));
    };
    /**
     * 监听合成的 `historyhashchange` 事件
     */


    this.onHistoryHashChangeInternal = function (params) {
      var type = params.type,
          oldURL = params.oldURL,
          newURL = params.newURL;
      var syntheticType = 'historyhashchange';
      var payload = {
        type: type,
        oldURL: oldURL,
        newURL: newURL
      };

      _this.emit(syntheticType, payload);
    };

    if (options.debug) {
      this.debug = options.debug;
    }

    this.subscribe();
  }
  /**
   * 释放资源
   */


  var _proto = HistoryObserver.prototype;

  _proto.dispose = function dispose() {
    this.emitter.all.clear();
    this.unsubscribe();
    undoInterceptHistory();
  }
  /**
   * 监听路由历史变化
   */
  ;

  _proto.on = function on(type, handler) {
    var _this2 = this;

    this.emitter.on(type, handler);
    return function () {
      return _this2.emitter.off(type, handler);
    };
  }
  /**
   * 监听原生 `load` 事件
   */
  ;

  _proto.onLoad = function onLoad(handler) {
    return this.on('load', handler);
  }
  /**
   * 监听原生 `popstate` 事件
   */
  ;

  _proto.onPopState = function onPopState(handler) {
    return this.on('popstate', handler);
  }
  /**
   * 监听原生 `hashchange` 事件
   */
  ;

  _proto.onHashChange = function onHashChange(handler) {
    return this.on('hashchange', handler);
  }
  /**
   * 监听自定义的 `pushstate` 事件
   */
  ;

  _proto.onPushState = function onPushState(handler) {
    return this.on('pushstate', handler);
  }
  /**
   * 监听自定义的 `replacestate` 事件
   */
  ;

  _proto.onReplaceState = function onReplaceState(handler) {
    return this.on('replacestate', handler);
  }
  /**
   * 监听路由变化
   */
  ;

  _proto.onHistoryChange = function onHistoryChange(handler) {
    return this.on('historychange', handler);
  }
  /**
   * 监听路由 hash 变化
   */
  ;

  _proto.onHistoryHashChange = function onHistoryHashChange(handler) {
    return this.on('historyhashchange', handler);
  };

  return HistoryObserver;
}();

var PushStateEvent = /*#__PURE__*/function (_PopStateEvent) {
  _inheritsLoose(PushStateEvent, _PopStateEvent);

  function PushStateEvent(typeArg, eventInitDict) {
    var _this;

    _this = _PopStateEvent.call(this, typeArg, eventInitDict) || this;
    _this.oldURL = '';
    _this.newURL = '';
    _this.state = null;

    if (eventInitDict) {
      var _eventInitDict$oldURL = eventInitDict.oldURL,
          oldURL = _eventInitDict$oldURL === void 0 ? '' : _eventInitDict$oldURL,
          _eventInitDict$newURL = eventInitDict.newURL,
          newURL = _eventInitDict$newURL === void 0 ? '' : _eventInitDict$newURL,
          _eventInitDict$state = eventInitDict.state,
          state = _eventInitDict$state === void 0 ? null : _eventInitDict$state;
      _this.oldURL = oldURL;
      _this.newURL = newURL;
      _this.state = state;
    }

    return _this;
  }

  _createClass(PushStateEvent, [{
    key: Symbol.toStringTag,
    get: function get() {
      return 'PushStateEvent';
    }
  }]);

  return PushStateEvent;
}( /*#__PURE__*/_wrapNativeSuper(PopStateEvent));
var ReplaceStateEvent = /*#__PURE__*/function (_PushStateEvent) {
  _inheritsLoose(ReplaceStateEvent, _PushStateEvent);

  function ReplaceStateEvent() {
    return _PushStateEvent.apply(this, arguments) || this;
  }

  _createClass(ReplaceStateEvent, [{
    key: Symbol.toStringTag,
    get: function get() {
      return 'ReplaceStateEvent';
    }
  }]);

  return ReplaceStateEvent;
}(PushStateEvent);

export { HistoryObserver, PushStateEvent, ReplaceStateEvent, interceptHistory, isHashEqual, log, undoInterceptHistory };
//# sourceMappingURL=browser-history-observer.esm.js.map
